/* import __COLOCATED_TEMPLATE__ from './add-mcp-server-modal.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { post } from 'embercom/lib/ajax';
import type IntlService from 'embercom/services/intl';
import type { Template } from './mcp-template-list';
import {
  MCP_SERVER_AUTHENTICATION_TYPES,
  SHOPIFY_URL_PLACEHOLDER,
} from 'embercom/models/workflow-connector/constants/mcp-templates';

interface Args {
  onModalClose: () => void;
  selectedTemplate: Template;
}

export default class AddMcpServerModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare router: $TSFixMe;
  @service declare redirectService: $TSFixMe;
  @service declare intl: IntlService;

  @tracked serverName = '';
  @tracked serverUrl = '';
  @tracked serverDescription = '';
  @tracked tokenValue = '';

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (this.args.selectedTemplate.template) {
      this.serverName = this.args.selectedTemplate.name;
    }
  }

  get isTemplateServer() {
    return this.args.selectedTemplate.template;
  }

  get modalTitle() {
    return this.isTemplateServer
      ? this.args.selectedTemplate.name
      : this.intl.t('workflow-connector.actions.mcp-actions.template-list.custom-mcp-title');
  }

  get submitButtonLabel() {
    return this.isTemplateServer
      ? this.intl.t(
          'workflow-connector.actions.mcp-actions.add-mcp-server-form.add-server-template-button',
          { name: this.args.selectedTemplate.name },
        )
      : this.intl.t(
          'workflow-connector.actions.mcp-actions.add-mcp-server-form.add-custom-server-button',
        );
  }

  get buildServerUrl() {
    if (this.isTemplateServer && this.args.selectedTemplate.name === 'Shopify') {
      return `${this.serverUrl}/api/mcp`;
    }

    return this.args.selectedTemplate.url;
  }

  get shopifyUrlPlaceholder() {
    return SHOPIFY_URL_PLACEHOLDER;
  }

  @task({ drop: true })
  *addMcpServer(): TaskGenerator<void> {
    try {
      if (this.isTemplateServer) {
        let response = yield post('/ember/workflow_connector/setup_mcp_actions/add_mcp_server', {
          app_id: this.appService.app.id,
          server_name: this.args.selectedTemplate.name,
          server_url: this.buildServerUrl,
          server_description: this.args.selectedTemplate.description,
          auth_type: this.args.selectedTemplate.authentication,
        });
        if (response.requires_oauth && response.authorization_url) {
          this.redirectService.redirect(response.authorization_url);
        } else {
          window.location.reload();
        }
      } else {
        let response = yield post(
          '/ember/workflow_connector/setup_mcp_actions/add_custom_mcp_server',
          {
            app_id: this.appService.app.id,
            auth_type: MCP_SERVER_AUTHENTICATION_TYPES.oauth,
            server_name: this.serverName,
            server_url: this.serverUrl,
            server_description: this.serverDescription,
          },
        );

        if (response.requires_oauth && response.authorization_url) {
          this.redirectService.redirect(response.authorization_url);
        }
      }
    } catch (error) {
      console.error('Error adding MCP server:', error);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::AddMcpServerModal': typeof AddMcpServerModal;
    'workflow-connector/add-mcp-server-modal': typeof AddMcpServerModal;
  }
}
